import type {Context} from '../types';

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;

  const isDivBlock = jsonNode.type === 'DivBlock';

  return {
    needed: isDivBlock,
    logData: {
      msg: 'Migrate DivBlock to Block',
      meta: {
        nodeId: jsonNode._id,
        type: jsonNode.type,
      },
    },
    apply: () => {
      jsonNode.type = 'Block';
    },
  };
};
